var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',[_c('Account'),(_vm.stripeAccount && _vm.stripeAccount.business_type=="company")?_c('Persons'):_vm._e(),(_vm.stripeAccount)?_c('Banks'):_vm._e(),(_vm.stripeAccount)?_c('Balance'):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }